export default __webpack_public_path__ + "20ec0ffc6d5a2275129ed0fbb3255431.jpg";